$color-background-blue: #6d95c3;
$color-white: #ffffff;
$color-orange: #ff6600;
$color-grey: #495057;
$color-light-grey: #d9d9d9;
$color-not-listed-btn-grey: #ebebeb;

.location__imageText {
  position: relative;
  z-index: 5;
  color: $color-white;
  text-align: center;

  h3 {
    font-size: 1.5rem;
  }

  @media (max-width: 991px) {
    text-align: left;
    p {
      font-size: 1.3rem;
    }
    h3 {
      font-size: 1.4rem;
    }
  }
}

.location__imageBackground {
  position: relative;
  @media (max-width: 991px) {
    margin-bottom: 30px;
    padding: 0;
  }
}

.location__imageBackground:after {
  content: "";
  width: 901px;
  height: 1006px;
  background-color: $color-background-blue;
  position: absolute;
  left: -64%;
  top: -89%;
  border-radius: 50%;

  @media (max-width: 1200px) {
    left: -89%;
  }
  @media (max-width: 991px) {
    left: -65%;
    top: -80%;
    width: 181%;
    height: 193%;
  }
}

.location__image {
  position: absolute;
  left: 40px;
  bottom: -371px;
  @media (max-width: 1200px) {
    bottom: -371px;
  }
}

.location__postcodeSearch {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 80px !important;

  @media (max-width: 991px) {
    padding: 0 !important;
  }

  @media (min-width: 992px) {
    height: 550px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 10px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
      border-radius: 10px;
    }
  }
}

.location__actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;

  a:hover {
    text-decoration: none;
  }

  button {
    width: 140px;
    &:hover {
      text-decoration: none;
    }
  }
}

.location__back {
  font-weight: 600;
}

.location__addressListContainer {
  border: 1px solid $color-light-grey;
  border-radius: 4px;
  position: relative;
}

.location__notListedBtn {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 10px;
  text-align: left;
  background-color: $color-not-listed-btn-grey;
  border: none;
  color: #024798;
  text-decoration: underline;
}
